import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import AcaoAuditoriaBadge from "../AcaoAuditoriaBadge";
import { formatarValorAuditoria } from "../../../main/services/AuditoriaService";
import { agruparEventosRelatorioAuditoria } from "../../utils/agruparEventosRelatorioAuditoria";

const LINHAS_PARA_MANTER_JUNTO = 4;

const CelulaValor = ({ valor, referencia }) => {
  const valorFormatado = formatarValorAuditoria(valor);
  if (!referencia) return <Text>{valorFormatado || "-"}</Text>;
  return (
    <Flex flexDir="column">
      <Text fontWeight={700} fontStyle="italic">
        {referencia}
      </Text>
      <Text>{valorFormatado || "-"}</Text>
    </Flex>
  );
};

export const AuditoriaRelatorioGrupos = ({ eventos }) => {
  const grupos = agruparEventosRelatorioAuditoria(eventos);

  if (grupos.length === 0) {
    return (
      <Text mt={6} color="#6B6C71">
        Nenhuma alteração encontrada no período pesquisado.
      </Text>
    );
  }

  return (
    <Box mt={6}>
      {grupos.map((grupo) => (
        <Box
          key={grupo.aba}
          mt={8}
          border="1px solid #D7D8DE"
          borderRadius="6px"
          pb={3}
        >
          <Box
            backgroundColor="#7A1F2B"
            color="#FFF"
            px={4}
            py={2}
            borderTopRadius="5px"
            css={{ breakAfter: "avoid" }}
          >
            <Text fontWeight={700}>{grupo.aba.toUpperCase()}</Text>
          </Box>

          {grupo.campos.map((campo, indiceCampo) => (
            <Box
              key={campo.campo}
              mt={indiceCampo === 0 ? 4 : 3}
              mx={3}
              pt={indiceCampo === 0 ? 0 : 3}
              borderTop={indiceCampo === 0 ? undefined : "1px solid #D7D8DE"}
              css={
                campo.linhas.length <= LINHAS_PARA_MANTER_JUNTO
                  ? { breakInside: "avoid" }
                  : undefined
              }
            >
              <Text fontWeight={700} mb={2} css={{ breakAfter: "avoid" }}>
                {campo.campo}
              </Text>
              <Box
                as="table"
                w="100%"
                fontSize="12px"
                style={{ borderCollapse: "collapse" }}
              >
                <Box as="thead">
                  <Box as="tr" borderBottom="1px solid #D7D8DE">
                    {[
                      "#",
                      "Valor Anterior",
                      "Valor Novo",
                      "Ação",
                      "Responsável",
                      "Data/Hora",
                    ].map((titulo) => (
                      <Box
                        as="th"
                        key={titulo}
                        textAlign="left"
                        py={2}
                        px={2}
                        backgroundColor="#EEF0F2"
                        color="#6B6C71"
                        textTransform="uppercase"
                        fontSize="11px"
                      >
                        {titulo}
                      </Box>
                    ))}
                  </Box>
                </Box>
                <Box as="tbody">
                  {campo.linhas.map((linha) => (
                    <Box
                      as="tr"
                      key={linha.key}
                      borderBottom="1px solid #EDEDED"
                      css={{ breakInside: "avoid" }}
                    >
                      <Box as="td" py={2} px={2} verticalAlign="top">
                        {String(linha.numero).padStart(2, "0")}
                      </Box>
                      <Box as="td" py={2} px={2} verticalAlign="top">
                        <CelulaValor
                          valor={linha.valorAnterior}
                          referencia={linha.referenciaRegistro}
                        />
                      </Box>
                      <Box as="td" py={2} px={2} verticalAlign="top">
                        <CelulaValor
                          valor={linha.valorNovo}
                          referencia={linha.referenciaRegistro}
                        />
                      </Box>
                      <Box as="td" py={2} px={2} verticalAlign="top">
                        <AcaoAuditoriaBadge acao={linha.acao} />
                      </Box>
                      <Box as="td" py={2} px={2} verticalAlign="top">
                        <Text>{linha.usuario}</Text>
                        <Text fontSize="11px" color="#6B6C71">
                          {linha.login}
                        </Text>
                        <Text
                          fontSize="11px"
                          color="#6B6C71"
                          fontStyle="italic"
                        >
                          {linha.perfil}
                        </Text>
                        {linha.orgao && (
                          <Text
                            fontSize="11px"
                            color="#6B6C71"
                            fontStyle="italic"
                          >
                            {linha.orgao}
                          </Text>
                        )}
                      </Box>
                      <Box
                        as="td"
                        py={2}
                        px={2}
                        whiteSpace="nowrap"
                        verticalAlign="top"
                      >
                        {linha.dataHora}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
